<script lang="ts">
    import type { Availability as AvailabilityType } from '@shared/types/types';
    import OttoUp from '@tile/components/otto-up/OttoUp.svelte';
    import Availability from '../availability/Availability.svelte';

    interface Props {
        availability: AvailabilityType | undefined;
        ottoUp: boolean | undefined;
    }

    let { availability, ottoUp }: Props = $props();
</script>

{#if availability || ottoUp}
    <div class="reptile-delivery">
        <Availability {availability} />
        <OttoUp show={ottoUp} />
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-delivery {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: tokens.$oc-semantic-spacing-75;
        width: 100%;
    }
</style>
